import Service from "../../../Service";
import Axios from "../../../Config/API";
import {
    IConfigTemplateFormulario,
    IVincularConfigTemplateFormulario,
} from "../../../../Interfaces/AssistenciaTecnica/Formularios/ConfigTemplateFormulario/ConfigTemplateFormularioInterfaces";

export async function VincularDocumentoTemplateFormularioService(
    vinculoDocumentoTemplateFormulario: IVincularConfigTemplateFormulario
) {
    return Service(
        Axios.post(
            `/home/doctemplateform/vinculardoctemplateform`,
            vinculoDocumentoTemplateFormulario
        )
    );
}

export async function ListarDocumentoTemplateFormularioService(
    idFormulario: number
) {
    return Service(
        Axios.get<Array<IConfigTemplateFormulario>>(
            `/home/doctemplateform/listardoctemplateform?idFormulario=${idFormulario}`
        )
    );
}

export async function DesvincularDocumentoTemplateFormularioService(
    idDocTempFormulario: number
) {
    return Service(
        Axios.delete(
            `/home/doctemplateform/desvinculardoctemplateform?idDocTempFormulario=${idDocTempFormulario}`
        )
    );
}
